/**
 * @module consentChecker
 * A module for checking if the user has given consent to cookies
 * and then loading the appropriate scripts and iframe elements
 * The iframe/script elements which this script deals with comes
 * from an oembed field in the CMS which renders iframes/scripts
 * with a data-customcookieyes attribute, this module will check
 * for consent and load those elements correctly if the user has
 * given consent to advertising cookies (we presume that's the
 * correct category for all embeds)
 *
 * @returns {void}
*/

const CONSENT_CHECK_MAX_ATTEMPTS = 50;
const CONSENT_CHECK_INTERVAL_MS = 300;

const initLogic = () => {
    if (window.getCkyConsent) {
        const consent = getCkyConsent();
        console.log('consentChecker - if getCkyConsent', consent);
        // retrieve consent from cookieyes
        if (consent.categories.advertisement) {
            // Check elements with data-customcookieyes
            // - where it is a script element change the type attribute to text/javascript
            // - where it is an iframe element change the data-src attribute to src
            const elements = document.querySelectorAll('[data-customcookieyes]');
            elements.forEach(element => {
                const wrapper = element.closest('.b-video__embed-wrapper');
                let processed = false;
                if (element.tagName === 'SCRIPT') {
                    // For some reason changing the type attribute isn't enough to initialise some scripts, so we just recreate a script element instead
                    const newScript = document.createElement('script');
                    Array.from(element.attributes).forEach(attr => {
                        if (attr.name !== 'type') {
                            newScript.setAttribute(attr.name, attr.value);
                        }
                    });
                    newScript.setAttribute('type', 'text/javascript');
                    if (element.innerHTML) {
                        newScript.innerHTML = element.innerHTML;
                    }
                    element.parentNode.replaceChild(newScript, element);
                    processed = true;
                } else if (element.tagName === 'IFRAME') {
                    element.setAttribute('src', element.getAttribute('data-src'));
                    element.removeAttribute('data-src');
                    element.style.display = 'block';
                    processed = true;
                }

                if (processed && wrapper) {
                    const thumbnail = wrapper.querySelector('.js-video-thumbnail');
                    if (thumbnail) {
                        thumbnail.remove();
                    }
                }
            });
        }
    } else {
        // check if getCkyConsent is defined 2 times per second for 10 seconds
        let attempts = 0;
        const checkInterval = setInterval(() => {
        if (window.getCkyConsent) {
            clearInterval(checkInterval);
            initLogic();
        } else {
            attempts++;
            if (attempts >= CONSENT_CHECK_MAX_ATTEMPTS) {
            clearInterval(checkInterval);
            console.error('consentChecker - timed out waiting for getCkyConsent');
            }
        }
        }, CONSENT_CHECK_INTERVAL_MS);
    }
}


export default function init() {
    initLogic();

    document.addEventListener('cookieyes_consent_update', () => {
        initLogic();
    });
}
